module.exports = __webpack_public_path__ + "img/Monte_Kope_85.bf4fb42c.jpg";